import { render } from "./ReportWidget.vue?vue&type=template&id=3894304f"
import script from "./ReportWidget.vue?vue&type=script&lang=js"
export * from "./ReportWidget.vue?vue&type=script&lang=js"

import "./ReportWidget.vue?vue&type=style&index=0&id=3894304f&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__